var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#12AED9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7571 13.6965C27.9164 13.6567 28.083 13.6567 28.2422 13.6965L38.9089 16.3632C39.354 16.4745 39.6663 16.8745 39.6663 17.3333V28C39.6663 32.4464 36.7179 36.0336 33.9915 38.4192C32.6073 39.6304 31.2278 40.5783 30.1963 41.223C29.6796 41.546 29.2475 41.7945 28.9423 41.9634C28.7897 42.0479 28.6686 42.1126 28.5843 42.1569C28.5422 42.179 28.5092 42.196 28.4861 42.2079L28.4589 42.2217L28.4509 42.2257L28.4484 42.227L28.4475 42.2274C28.4472 42.2276 28.4469 42.2278 27.9997 41.3333C27.5525 42.2278 27.5522 42.2276 27.5518 42.2274L27.5509 42.227L27.5484 42.2257L27.5405 42.2217L27.5133 42.2079C27.4902 42.196 27.4572 42.179 27.415 42.1569C27.3308 42.1126 27.2097 42.0479 27.057 41.9634C26.7519 41.7945 26.3198 41.546 25.803 41.223C24.7715 40.5783 23.3921 39.6304 22.0078 38.4192C19.2814 36.0336 16.333 32.4464 16.333 28V17.3333C16.333 16.8745 16.6453 16.4745 17.0905 16.3632L27.7571 13.6965ZM27.9997 41.3333L27.5525 42.2278C27.834 42.3685 28.1654 42.3685 28.4469 42.2278L27.9997 41.3333ZM27.9997 40.1992C28.2766 40.0454 28.668 39.8197 29.1363 39.527C30.1049 38.9217 31.3921 38.0362 32.6745 36.9141C35.2814 34.633 37.6663 31.5536 37.6663 28V18.1141L27.9997 15.6974L18.333 18.1141V28C18.333 31.5536 20.7179 34.633 23.3248 36.9141C24.6073 38.0362 25.8945 38.9217 26.863 39.527C27.3314 39.8197 27.7228 40.0454 27.9997 40.1992Z",
    fill: "#12AED9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.f74def9724ece9ebd3ec186fefd59735.svg";
export { ForwardRef as ReactComponent };